import { render, staticRenderFns } from "./UModalQues.vue?vue&type=template&id=3b6ded26&scoped=true&"
import script from "./UModalQues.vue?vue&type=script&lang=js&"
export * from "./UModalQues.vue?vue&type=script&lang=js&"
import style0 from "./UModalQues.vue?vue&type=style&index=0&id=3b6ded26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6ded26",
  null
  
)

export default component.exports